import { FormatNumberOptions } from 'react-intl';
import { GiftCard } from '../slices/cart/types';
import messages from './messages';

export const calculateTotalGiftCards = ({
  giftCards = [] as GiftCard[],
}): number =>
  giftCards.reduce((acc, giftCard) => acc + giftCard.amount.centAmount, 0);

export const getLastURIComponent = (): string => {
  const components = window.location.href.split('/');
  let lastURIComponent =
    components[components.length - 1] === ''
      ? components[components.length - 2]
      : components[components.length - 1];
  [lastURIComponent] = lastURIComponent.split('?');
  return lastURIComponent || '';
};

export const priceToString = ({
  price,
  formatNumber,
  formatMessage,
  forceDigit = false,
  maximumFractionDigits,
  minimumFractionDigits = 0,
}: {
  price: { centAmount: number; fractionDigits?: number; currencyCode?: string };
  formatNumber: (
    this: void,
    value: number | bigint,
    opts?: FormatNumberOptions | undefined,
  ) => string;
  formatMessage: (
    messageDescriptor: { id: string; defaultMessage?: string },
    values?: Record<string, string | number>,
  ) => string;
  forceDigit?: boolean;
  maximumFractionDigits?: number;
  minimumFractionDigits?: number;
}) => {
  if (!price?.centAmount && !forceDigit) {
    return formatMessage(messages.free);
  }
  return formatNumber(price.centAmount / 10 ** (price.fractionDigits ?? 0), {
    style: 'currency',
    currency: price.currencyCode || 'USD',
    maximumFractionDigits: maximumFractionDigits ?? price.fractionDigits,
    minimumFractionDigits:
      (minimumFractionDigits ?? maximumFractionDigits === 0) ? 0 : undefined,
  });
};
